var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4194 34.1255V58.597C48.4194 61.3584 46.1808 63.597 43.4194 63.597H16C13.2386 63.597 11 61.3584 11 58.597V25.3066C11 22.5452 13.2386 20.3066 16 20.3066H35.7764C37.2264 20.3066 38.6051 20.9362 39.5548 22.032L47.1978 30.8508C47.9857 31.7599 48.4194 32.9225 48.4194 34.1255Z",
    stroke: "#3CEAC1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8708 20.1454V19.2744C15.8708 16.513 18.1094 14.2744 20.8708 14.2744H41.6472C43.3873 14.2744 45.0417 15.0299 46.1813 16.3448L53.8243 25.1637C54.7698 26.2546 55.2902 27.6497 55.2902 29.0933V54.5647C55.2902 57.3262 53.0516 59.5647 50.2902 59.5647H48.5805",
    stroke: "#3CEAC1",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5808 14.2743V13.4033C22.5808 10.6419 24.8194 8.40332 27.5808 8.40332H48.3572C50.0973 8.40332 51.7517 9.15876 52.8913 10.4737L60.5343 19.2926C61.4797 20.3835 62.0002 21.7786 62.0002 23.2222V48.6936C62.0002 51.4551 59.7616 53.6936 57.0002 53.6936H55.2905",
    stroke: "#3CEAC1",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8389 20.1453V30.7259C36.8389 31.8305 37.7343 32.7259 38.8389 32.7259H48.5808",
    stroke: "#3CEAC1",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5483 15.113V24.855C43.5483 25.9595 44.4438 26.855 45.5483 26.855H54.4516",
    stroke: "#3CEAC1",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2581 9.24194V18.9839C50.2581 20.0884 51.1535 20.9839 52.2581 20.9839H61.1613",
    stroke: "#3CEAC1",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8708,
    y: 26.1775,
    width: 7.22581,
    height: 7.22581,
    rx: 2,
    stroke: "#3CEAC1",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7097 40.2744L42.7097 40.2744",
    stroke: "#3CEAC1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7097 46.1453L42.7097 46.1453",
    stroke: "#3CEAC1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7097 52.0161L42.7097 52.0161",
    stroke: "#3CEAC1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7097 57.8872L42.7097 57.8872",
    stroke: "#3CEAC1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.eac186bb5e1bc97db8688fde12e7f437.svg";
export { ForwardRef as ReactComponent };